import { UseWizardFormResult } from '../hooks/useWizzardForm';
import { createContext, useContext } from 'react';
import { Tab } from 'react-bootstrap';

export const WizardFormContext = createContext(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  {}
);

const WizardFormProvider = ({ children, ...rest }) => {
  const { selectedStep, goToStep } = rest;
  return (
    <WizardFormContext.Provider value={{ ...rest }}>
      <Tab.Container
        activeKey={selectedStep}
        onSelect={eventKey => {
          if (eventKey) {
            goToStep(Number(eventKey));
          }
        }}
      >
        {children}
      </Tab.Container>
      {/* <WizardAccessDeniedModal /> */}
    </WizardFormContext.Provider>
  );
};

export const useWizardFormContext = () => useContext(WizardFormContext);

export default WizardFormProvider;
